export default __webpack_public_path__ + "69140807e00afa746932e31a0b91515b.png";